import { render, staticRenderFns } from "./registerSectorStep1Page.vue?vue&type=template&id=6dc109de&scoped=true&"
import script from "./registerSectorStep1Page.vue?vue&type=script&lang=js&"
export * from "./registerSectorStep1Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc109de",
  null
  
)

export default component.exports